/* eslint-disable react-hooks/exhaustive-deps */
import DependencyTable from '@components/UI/TodoTable/DependencyTable';
import { useQuery } from '@Helper/utils';
import SearchIcon from '@mui/icons-material/Search';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { IconButton, InputBase, Paper, Tab } from '@mui/material';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { Icons } from '../../../assets/SvgIcons';
import TodoCard from '../../../components/UI/TodoCard/TodoCard';
import { PageType, TaskViewType } from '../../../config/enum';
import { FilterIProps } from '../../../config/filter';
import { DateRanger } from '../../../config/range';
import { ComponentHelper } from '../../../helper/Infra';
import { ICTask } from '../../../helper/Interfaces';
import { getAssets } from '../../../store/feature/assetsSlice';
import {
  getPlayBookDetail,
  postDealTaskList,
} from '../../../store/feature/playBookDetailSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import DependencyItem from '../components/DependencyItem/DependencyItem';
import MergefloDependencyFilters from '../components/MergefloDependencyFilter';

interface ListTabProps {
  taskList: Array<ICTask>;
  filteredPlayBookId?: FilterIProps;
  directedFilters: FilterIProps[];
  isImo: boolean;
}

export default function ListTab(props: ListTabProps) {
  const [newTaskVisible] = useState<boolean>(false);

  const { taskList, filteredPlayBookId, directedFilters, isImo } = props;

  const { dealTaskList } = useAppSelector(getPlayBookDetail);
  const [myTaskList, setMyTaskList] = React.useState<ICTask[]>(
    dealTaskList.filter(
      t => t.type === 'dependency' && t.projectRelType === 'target'
    )
  );
  const { functionalAreas, playbooks } = useAppSelector(getAssets);
  const [filterReset, setFiilterReset] = React.useState(false);
  const { id } = useParams();
  const { t } = useTranslation();
  let query = useQuery();
  const dependencTab = query.get('dependencTab');
  const source = query.get('source');
  const target = query.get('target');

  const dispatch = useAppDispatch();

  const [tabIndex, setTabIndex] = useState<string>('1');

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setTabIndex(newValue);
  };

  const componentHelper = new ComponentHelper();

  /// Filters ////
  const [searchString, setsearchString] = useState('');
  const [likelihoodFilter, setLikelihoodFilter] = useState<FilterIProps[]>([]);
  const [statusFilter, setStatusFilter] = useState<FilterIProps[]>([]);
  const [sourceFunctionalAreaFilter, setSourceFunctionalAreasFilter] = useState<
    FilterIProps[]
  >([]);
  const [targetFunctionalAreaFilter, setTargetFunctionalAreaFilter] = useState<
    FilterIProps[]
  >([]);
  const [createdDateFilter, setCreateDateFilter] = useState<FilterIProps[]>([]);
  const [createRangeFilter, setCreateRangeFilter] = React.useState<DateRanger>({
    selection: {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    },
  });
  const [progressFilter, setProgressFilter] = useState<FilterIProps[]>([]);
  const [dueDateFilter, setDueDateFilter] = useState<FilterIProps[]>([]);
  const [assigneeFilter, setAssigneeFilter] = useState<FilterIProps[]>([]);
  const [moreFilter, setMoreFilter] = useState<FilterIProps[]>([]);
  const [rangeFilter, setRangeFilter] = React.useState<DateRanger>({
    selection: {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    },
  });
  /// Filters ////

  const targetFunctions = playbooks?.filter(a => a.dealspaceId === id!);

  const updateTaskProperty = async (
    taskId: string,
    taskProperty: string,
    value: any
  ) => {
    const updateTemplate = {
      id: taskId,
    };
    (updateTemplate as any)[taskProperty] = value;

    const data = await componentHelper.updateTask(updateTemplate);
    if (data.length > 0) {
      let newTaskList = JSON.parse(JSON.stringify(dealTaskList)) as ICTask[];
      const affectedDependencies = newTaskList.filter(i => i.id === taskId);
      newTaskList = newTaskList.filter(i => i.id !== taskId);
      for (const item of affectedDependencies) {
        (item as any)[taskProperty] = value;
      }
      newTaskList = [...newTaskList, ...affectedDependencies];
      dispatch(postDealTaskList(newTaskList));
    }
  };

  useEffect(() => {
    let pureTaskList = [...taskList];

    if (statusFilter.length > 0) {
      const newFiltered = [] as ICTask[];
      for (const status of statusFilter) {
        if (status.key === '1') {
          const sort = pureTaskList.filter(
            i => i.dueDate && new Date() > new Date(i.dueDate)
          );
          for (const s of sort) {
            newFiltered.push(s);
          }
        } else if (status.key === '2') {
          const sort = pureTaskList.filter(
            t =>
              (!t.dueDate && (t.riskCount! > 0 || t.issueCount! > 0)) ||
              (t.dueDate &&
                new Date() < new Date(t.dueDate) &&
                (t.riskCount! > 0 || t.issueCount! > 0))
          );

          for (const s of sort) {
            newFiltered.push(s);
          }
        } else if (status.key === '3') {
          const sort = pureTaskList.filter(
            pt =>
              pt.dueDate &&
              new Date(pt.dueDate) > new Date() &&
              (!pt.riskCount || pt.riskCount === 0) &&
              (!pt.issueCount || pt.issueCount === 0)
          );
          for (const s of sort) {
            newFiltered.push(s);
          }
        } else {
          const sort = pureTaskList.filter(
            pt =>
              !pt.dueDate &&
              (!pt.riskCount || pt.riskCount === 0) &&
              (!pt.issueCount || pt.issueCount === 0)
          );
          for (const s of sort) {
            newFiltered.push(s);
          }
        }
      }
      console.log('newFiltered', newFiltered);

      pureTaskList = Array.from(new Set(newFiltered as ICTask[]));
    }
    if (sourceFunctionalAreaFilter.length > 0) {
      pureTaskList = pureTaskList.filter(t =>
        sourceFunctionalAreaFilter
          .map(f => f.key)
          .includes(t.dependencySource ?? '')
      );
    }
    if (targetFunctionalAreaFilter.length > 0) {
      pureTaskList = pureTaskList.filter(t =>
        targetFunctionalAreaFilter
          .map(f => f.key)
          .includes(t.dependencyTarget ?? '')
      );
    }
    if (searchString.trim() !== '') {
      pureTaskList = pureTaskList.filter(t =>
        t.name ? (t.name.replace(/İ/gim, "i").toLowerCase().includes(searchString.trim().replace(/İ/gim, "i").toLowerCase()) ) : null
      );
    }
    if (dueDateFilter.length > 0) {
      pureTaskList = pureTaskList.filter(
        t =>
          moment(t.dueDate).toDate() >
            (rangeFilter.selection.startDate as Date) &&
          (rangeFilter.selection.endDate as Date) > moment(t.dueDate).toDate()
      );
    }
    if (createdDateFilter.length > 0) {
      pureTaskList = pureTaskList.filter(
        t =>
          moment(t.createdAt).toDate() >
            (createRangeFilter.selection.startDate as Date) &&
          (createRangeFilter.selection.endDate as Date) >
            moment(t.createdAt).toDate()
      );
    }
    if (moreFilter.length > 0) {
      if (moreFilter.filter(m => m.key === 'hasRisks').length > 0) {
        pureTaskList = pureTaskList.filter(t => t.riskCount && t.riskCount > 0);
      }
      if (moreFilter.filter(m => m.key === 'hasIssues').length > 0) {
        pureTaskList = pureTaskList.filter(
          t => t.issueCount && t.issueCount > 0
        );
      }
      if (moreFilter.filter(m => m.key === 'hasDecision').length > 0) {
        pureTaskList = pureTaskList.filter(
          t => t.decisionCount && t.decisionCount > 0
        );
      }
      if (moreFilter.filter(m => m.key === 'hasDependencies').length > 0) {
        pureTaskList = pureTaskList.filter(
          t => t.dependenciesCount && t.dependenciesCount > 0
        );
      }
      if (moreFilter.filter(m => m.key === 'uncompleted').length > 0) {
        pureTaskList = pureTaskList.filter(t => t.isCompleted === false);
      }
      if (moreFilter.filter(m => m.key === 'completed').length > 0) {
        pureTaskList = pureTaskList.filter(t => t.isCompleted === true);
      }
    }
    if (assigneeFilter.length > 0) {
      let assignedTaskList = [] as ICTask[];

      if (assigneeFilter.filter(a => a.key === '0').length > 0) {
        assignedTaskList = pureTaskList.filter(i => !i.assignee);
      }
      assignedTaskList = assignedTaskList.concat(
        pureTaskList.filter(t =>
          assigneeFilter.map(i => i.key).includes(t.assignee ?? '')
        )
      );
      pureTaskList = assignedTaskList;
    }
    if (likelihoodFilter.length > 0) {
      const newFiltered = [] as ICTask[];
      for (const likelihood of likelihoodFilter) {
        if (likelihood.key === 'unassigned') {
          const newCollection = pureTaskList.filter(
            t => !t.issueImpact || t.issueImpact === 'none'
          );
          for (const elem of newCollection) {
            newFiltered.push(elem);
          }
        } else {
          const newCollection = pureTaskList.filter(
            t => t.issueImpact === likelihood.key
          );
          for (const elem of newCollection) {
            newFiltered.push(elem);
          }
        }
      }

      pureTaskList = Array.from(new Set(newFiltered as ICTask[]));
    }
    console.log('pureTaskList', pureTaskList);

    setMyTaskList(pureTaskList);
  }, [
    taskList,
    statusFilter,
    sourceFunctionalAreaFilter,
    progressFilter,
    dueDateFilter,
    assigneeFilter,
    moreFilter,
    searchString,
    likelihoodFilter,
    rangeFilter,
    createdDateFilter,
    targetFunctionalAreaFilter,
  ]);

  useEffect(() => {
    if (directedFilters.length === 1 && !filterReset) {
      for (const item of directedFilters) {
        if (item.key === moment().format('MM-DD-YYYY')) {
          setCreateRangeFilter({
            selection: {
              endDate: moment().endOf('day').toDate(),
              startDate: moment().subtract('7', 'day').toDate(),
              key: 'selection',
            },
          });
          setCreateDateFilter([
            {
              key: moment().format('MM-DD-YYYY'),
              value: 'Created Date:' + moment().format('MM-DD-YYYY'),
            },
          ]);
        } else if (['completed', 'uncompleted'].includes(item.key)) {
          setMoreFilter(directedFilters);
        }
      }
    } else if (directedFilters.length > 1) {
      for (const item of directedFilters) {
        if (item.key === moment().format('MM-DD-YYYY')) {
          setCreateRangeFilter({
            selection: {
              endDate: moment().endOf('day').toDate(),
              startDate: moment().subtract('7', 'day').toDate(),
              key: 'selection',
            },
          });
          setCreateDateFilter([
            {
              key: moment().format('MM-DD-YYYY'),
              value: 'Created Date:' + moment().format('MM-DD-YYYY'),
            },
          ]);
        } else if (['completed', 'uncompleted'].includes(item.key)) {
          setMoreFilter([item]);
        }
      }
    }
  }, [directedFilters, filterReset]);

  useEffect(() => {
    console.log('filteredPlayBookId', filteredPlayBookId);

    if (filteredPlayBookId && !filterReset) {
      if (filteredPlayBookId.targetId) {
        setTargetFunctionalAreaFilter([
          {
            key: filteredPlayBookId.targetId ?? filteredPlayBookId.key,
            value: filteredPlayBookId.value,
          },
        ]);
      } else {
        setSourceFunctionalAreasFilter([filteredPlayBookId]);
      }
    }
  }, [filteredPlayBookId, filterReset]);

  useEffect(() => {
    if (dependencTab && dependencTab === 'incoming') {
      setTabIndex('1');
    } else if (dependencTab && dependencTab === 'outgoing') {
      setTabIndex('2');
    }
  }, [dependencTab]);

  useEffect(() => {
    const sourceFilter = functionalAreas?.find(
      item => item.shortName === source
    );
    const targetFilter = functionalAreas?.find(
      item => item.shortName === target
    );
    if (
      sourceFilter &&
      !sourceFunctionalAreaFilter?.find(item => item.key === sourceFilter.id)
    ) {
      setSourceFunctionalAreasFilter(old => [
        ...old,
        { key: sourceFilter.id, value: sourceFilter.shortName },
      ]);
    }
    if (
      targetFilter &&
      !targetFunctionalAreaFilter?.find(item => item.key === targetFilter.id)
    ) {
      setTargetFunctionalAreaFilter(old => [
        ...old,
        { key: targetFilter.id, value: targetFilter.shortName },
      ]);
    }
    console.log(sourceFilter);
  }, [source, target]);

  return (
    <>
      {!newTaskVisible ? (
        <>
          <div className="h-90p">
            <div
              className="pt-3 pb-3 "
              style={{ paddingLeft: 25, paddingRight: 53 }}
            >
              <div
                className="invite-playbook-header"
                style={{ marginBottom: 30 }}
              >
                <div className="invite-playbook-header-row">
                  <div className="search">
                    <Paper
                      component="form"
                      sx={{
                        p: '2px 4px',
                        display: 'flex',
                        alignItems: 'center',
                        width: 290,
                        borderRadius: 1,
                        background: '#FAFBFC',
                        border: 2,
                        borderColor: '#DFE1E6',
                        borderStyle: 'solid',
                        boxShadow: 'none',
                        height: 40,
                      }}
                    >
                      <IconButton
                        type="submit"
                        sx={{ p: '10px' }}
                        aria-label="search"
                      >
                        <SearchIcon />
                      </IconButton>
                      <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        placeholder={t('dependencies.list_tab.search')}
                        inputProps={{ 'aria-label': 'Search dependencies' }}
                        value={searchString}
                        onChange={evt => setsearchString(evt.target.value)}
                      />
                    </Paper>
                  </div>
                  <MergefloDependencyFilters
                    assigneeFilter={assigneeFilter}
                    dueDateFilter={dueDateFilter}
                    functionalAreasFilter={sourceFunctionalAreaFilter}
                    setFunctionalAreasFilter={setSourceFunctionalAreasFilter}
                    statusFilter={statusFilter}
                    rangeFilter={rangeFilter}
                    setRangeFilter={setRangeFilter}
                    progressFilter={progressFilter}
                    setProgressFilter={setProgressFilter}
                    setMoreFilter={setMoreFilter}
                    moreFilter={moreFilter}
                    setAssigneeFilter={setAssigneeFilter}
                    setDueDateFilter={setDueDateFilter}
                    setStatusFilter={setStatusFilter}
                    likelihoodFilter={likelihoodFilter}
                    setLikelihoodFilter={setLikelihoodFilter}
                    createRangeFilter={createRangeFilter}
                    createdDateFilter={createdDateFilter}
                    setCreateDateFilter={setCreateDateFilter}
                    setCreateRangeFilter={setCreateRangeFilter}
                    targetFunctionalAreaFilter={targetFunctionalAreaFilter}
                    setTargetFunctionalAreaFilter={
                      setTargetFunctionalAreaFilter
                    }
                  />
                  {statusFilter.length ||
                  sourceFunctionalAreaFilter.length ||
                  progressFilter.length ||
                  dueDateFilter.length ||
                  assigneeFilter.length ||
                  likelihoodFilter.length ||
                  moreFilter.length ? (
                    <div
                      style={{ display: 'flex', cursor: 'pointer' }}
                      id="reset-button"
                      onClick={() => {
                        setStatusFilter([]);
                        setSourceFunctionalAreasFilter([]);
                        setProgressFilter([]);
                        setDueDateFilter([]);
                        setAssigneeFilter([]);
                        setLikelihoodFilter([]);
                        setMoreFilter([]);
                        setFiilterReset(true);
                      }}
                    >
                      <div
                        style={{
                          width: 0,
                          height: '20.27px',
                          border: '1px solid #C2C1D0',
                        }}
                      ></div>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          padding: '0 4px',
                        }}
                      >
                        <div style={{ padding: '0 2px', display: 'flex' }}>
                          <Icons.Cancel
                            width="15"
                            height="15"
                            color="#46426E"
                          />
                        </div>
                        <div
                          style={{
                            color: '#46426E',
                            fontFamily: 'Inter',
                            padding: '0 2px',
                          }}
                        >
                          {t('dependencies.list_tab.reset_filter')}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
            <div style={{ paddingLeft: 17, paddingRight: 37 }}>
              <TabContext value={tabIndex}>
                <TabList
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                  className="dependencies-list-TabList"
                >
                  <Tab
                    label={
                      isImo
                        ? t('dependencies.dependencies_header')
                        : t('dashboard.dependencies_incoming')
                    }
                    value="1"
                  />
                </TabList>
                <TabPanel value="1">
                  <div className="invite-playbook-header">
                    <div
                      style={{
                        color: '#292558',
                        fontWeight: 600,
                        fontSize: 16,
                        fontFamily: 'Inter',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        borderRadius: '4px 4px 0 0',
                      }}
                    >
                      <div aria-label="delete"></div>
                    </div>
                  </div>
                  <div
                    style={{
                      margin: '5px 0',
                      paddingBottom: '100px',
                    }}
                  >
                    <DependencyTable
                      taskList={Array.from(
                        new Set(
                          myTaskList.filter(
                            t =>
                              t.type === 'dependency' &&
                              t.projectRelType === 'target'
                          )
                        )
                      ).filter(
                        i =>
                          targetFunctions
                            ?.map(t => t.functionalAreaId)
                            .includes(i.dependencyTarget ?? '') &&
                          i.parentTaskName !== undefined
                      )}
                      updateTaskProperty={updateTaskProperty}
                      editable={true}
                    />
                    {/* {Array.from(new Set(myTaskList))
                      .filter(
                        i =>
                          targetFunctions
                            ?.map(t => t.functionalAreaId)
                            .includes(i.dependencyTarget ?? '') &&
                          i.parentTaskName !== undefined
                      )
                      .map(mt => {
                        return (
                          <TodoCard
                            key={mt.id}
                            subTaskCount={mt.subTaskCount ?? 0}
                            subRiskCount={mt.riskCount ?? 0}
                            subIssueCount={mt.issueCount ?? 0}
                            subDecisionCount={mt.decisionCount ?? 0}
                            subDependencyCount={mt.dependenciesCount ?? 0}
                            task={mt}
                            taskViewType={TaskViewType.LIST}
                            pageType={PageType.DEPENDENCIES}
                            startDate={mt.startDate}
                            updateTaskDate={updateTaskDate}
                            updateTaskProperty={updateTaskProperty}
                            updateTaskName={updateTaskName}
                            updateTask={updateTask}
                            shadowTitle={
                              mt.name === ' '
                                ? '(' +
                                  (functionalAreas?.find(
                                    f => f.id === mt.dependencySource
                                  )?.shortName ?? '') +
                                  ' - ' +
                                  (functionalAreas?.find(
                                    f => f.id === mt.dependencyTarget
                                  )?.shortName ?? '') +
                                  ')' +
                                  (mt.parentTaskName ?? '')
                                : mt.name
                            }
                            dependency={DependencyItem(mt)}
                          />
                        );
                      })} */}
                  </div>
                </TabPanel>
                <TabPanel value="2">
                  <div className="pt-3 pb-3 ">
                    <div className="invite-playbook-header">
                      <div
                        style={{
                          color: '#292558',
                          fontWeight: 600,
                          fontSize: 16,
                          fontFamily: 'Inter',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'flex-start',
                          borderRadius: '4px 4px 0 0',
                        }}
                      ></div>
                    </div>
                    <div>
                      {/* {myTaskList
                        .filter(
                          i =>
                            targetFunctions
                              ?.map(t => t.functionalAreaId)
                              .includes(i.dependencySource ?? '') &&
                            i.parentTaskName === undefined
                        )
                        .map(t => {
                          return <DependencyCard key={t.id} dependencies={t} />;
                        })} */}
                      {myTaskList
                        .filter(
                          i =>
                            targetFunctions
                              ?.map(t => t.functionalAreaId)
                              .includes(i.dependencySource ?? '') &&
                            i.parentTaskName === undefined
                        )
                        .map(t => {
                          return (
                            <TodoCard
                              key={t.id}
                              task={t}
                              subTaskCount={t.subTaskCount ?? 0}
                              startDate={t.startDate}
                              taskViewType={TaskViewType.LIST}
                              pageType={PageType.DEPENDENCIES}
                              shadowTitle={
                                t.name === ' '
                                  ? '(' +
                                    (functionalAreas?.find(
                                      f => f.id === t.dependencySource
                                    )?.shortName ?? '') +
                                    ' - ' +
                                    (functionalAreas?.find(
                                      f => f.id === t.dependencyTarget
                                    )?.shortName ?? '') +
                                    ')' +
                                    (t.parentTaskName ?? '')
                                  : t.name
                              }
                              dependency={<DependencyItem task={t} />}
                            />
                          );
                        })}
                    </div>
                  </div>
                </TabPanel>
              </TabContext>
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
}
